export default function Legend() {
    return (
        <div className="texto-legenda">

            <span>
                <span className="circulo-status-legenda normal"></span>
                Operacional
            </span>

            <span>
                <span className="circulo-status-legenda degradado"></span>
                Operando com restrições
            </span>

            <span>
                <span className="circulo-status-legenda maintenance"></span>
                Em manutenção
            </span>

            <span>
                <span className="circulo-status-legenda critico"></span>
                Alarme Critico
            </span>

            <span>
                <span className="circulo-status-legenda desligado"></span>
                Desligado
            </span>

        </div>
    );
}